/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
import SearchLei from 'components/atoms/search_lei';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { search_law } from 'store/modules/juridico_facil_store/actions';
import { ApplicationState } from 'store';
import Pagination from 'components/atoms/pagination';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import EmptyResult from 'components/atoms/empty_result';
import Loader from 'components/atoms/loader';
import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';

interface LegislationSearchProps {
  params: {
    search?: string;
    accept?: boolean;
    unica_lei?: number;
    tipo?: string;
  };
}

const LegislationSearch = (props: LegislationSearchProps) => {
  const { params } = props;
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { juridico, request } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  useEffect(() => {
    document.title = 'Jurídico Fácil - ConLicitação';
    dispatch(search_law(params, currentPage));
  }, [currentPage]);

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  return (
    <Container>
      <div className="container p-4 mt-5">
        <div className="row">
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center my-3">
              <h4 className="mb-1 mr-3 font-weight-bold">Jurídico Fácil</h4>
              <OpenTutorial type="modal" source="juridico" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <SearchLei params={params} />

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/juridico">Inicio</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/legislacao">Leis</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Legislações
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="card  mb-3" style={{ maxWidth: '18rem' }}>
              <div className="card-header">Ocorrências encontradas</div>
              <div className="card-body">
                {juridico?.quantidade_por_lei[0]?.leis?.length > 0 && (
                  <>
                    <h5 className="card-title">Leis</h5>
                    {juridico?.quantidade_por_lei[0]?.leis?.map((k) => (
                      <div key={k?.id}>
                        <a
                          href={`/legislacao/show/${params?.search}/${params?.accept}/${k?.id}/lei`}
                        >
                          {`${k?.tipo} ${k?.esfera} nº ${k?.lei}`}
                          <span className="badge badge-secondary ml-2">{k?.ocorrencia}</span>
                        </a>
                      </div>
                    ))}
                    <hr />
                  </>
                )}
                {juridico?.quantidade_por_lei[0]?.decretos?.length > 0 && (
                  <>
                    <h5 className="card-title">Decreto</h5>
                    {juridico?.quantidade_por_lei[0]?.decretos?.map((k) => (
                      <div key={k?.id}>
                        <a
                          href={`/legislacao/show/${params?.search}/${params?.accept}/${k?.id}/decreto`}
                        >
                          {`${k?.tipo} ${k?.esfera} nº ${k?.lei}`}
                          <span className="badge badge-secondary ml-2">{k?.ocorrencia}</span>
                        </a>
                      </div>
                    ))}
                    <hr />
                  </>
                )}
                {juridico?.quantidade_por_lei[0]?.decretos?.length > 0 && (
                  <>
                    <h5 className="card-title">Constituição Federal</h5>
                    {juridico?.quantidade_por_lei[0]?.constituciones.map((k) => (
                      <div key={k?.id}>
                        <a
                          href={`/legislacao/show/${params?.search}/${params?.accept}/${k?.id}/constituicao`}
                        >
                          {`${k?.tipo} ${k?.esfera} nº ${k?.lei}`}
                          <span className="badge badge-secondary ml-2">{k?.ocorrencia}</span>
                        </a>
                      </div>
                    ))}
                    <hr />
                  </>
                )}
                {juridico?.quantidade_por_lei[0]?.leis_complementares?.length > 0 && (
                  <>
                    <h5 className="card-title">Lei complementar</h5>
                    {juridico?.quantidade_por_lei[0]?.constituciones?.map((k) => (
                      <div key={k?.id}>
                        <a href="#">
                          {`${k?.tipo} ${k?.esfera} nº ${k?.lei}`}
                          <span className="badge badge-secondary ml-2">{k?.ocorrencia}</span>
                        </a>
                      </div>
                    ))}
                    <hr />
                  </>
                )}
                {juridico?.quantidade_por_lei[0]?.medidas_provisorias.length > 0 && (
                  <>
                    <h5 className="card-title">Medida Provisória</h5>
                    {juridico?.quantidade_por_lei[0]?.constituciones.map((k) => (
                      <div key={k?.id}>
                        <a href="#">
                          {`${k?.tipo} ${k?.esfera} nº ${k?.lei}`}
                          <span className="badge badge-secondary ml-2">{k?.ocorrencia}</span>
                        </a>
                      </div>
                    ))}
                    <hr />
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-9">
            {request?.search_law?.loading ? (
              <Loader />
            ) : (
              juridico?.exibir?.map((t) => (
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <nav>
                          <ol className="breadcrumb breadcrumb-custom">
                            <li className="breadcrumb-item">
                              <a href="#" data-abc="true">
                                <strong>{t?.tipo}</strong>
                              </a>
                            </li>
                            <li className="breadcrumb-item">
                              <a href="#" data-abc="true" className="ml-2">
                                {t?.lei}
                              </a>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                    <a
                      href={`/legislacao/lei/${t?.id}`}
                      className="link_acervo"
                      dangerouslySetInnerHTML={{
                        __html: t?.ocorrencia.replace(
                          new RegExp(`(${params?.search})`, 'gi'),
                          '<span class="badge badge-warning">$1</span>',
                        ),
                      }}
                    />
                  </div>
                </div>
              ))
            )}
            {juridico?.total_registros > 10 && (
              <div className="row d-print-none mt-3">
                <div className="col-md-12 px-4 mb-5">
                  <Pagination
                    postsPerPage={10}
                    totalPosts={juridico?.total_registros}
                    paginate={paginate}
                    currentPage={currentPage}
                    firstAndLastPage
                  />
                </div>
              </div>
            )}
            {request?.search_law?.loaded && juridico?.exibir?.length === 0 && (
              <EmptyResult
                title="Desculpe!"
                description="Ops, nada encontrado! Tente pesquisar com outra palavra-chave."
              />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default LegislationSearch;
